<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Date Range</h4>
  <button type="button"
          class="close btn"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!--
  Body
-->
<div class="modal-body">
  <div class="container-fluid">
    <div class="row">
      <!--Eventually - we will need to move this message block into a date-range-header slot for cross domain flexibility.-->
      <div class='selection-message'>
        <span class="fw-bold pe-1">{{ selectedDateRange.fromDate | cstDate: 'll' }} -
          {{ selectedDateRange.toDate | cstDate: 'll' }}</span>
        <span class="text-muted h6">{{ selectedDateRange | monthsBetween}} months of spend</span>


        <span data-test-selector='icon-and-messages-container'
              class='icon-and-messages-container'
              *ngIf="didSetCustomDateRange">
          <i class='fa fa-exclamation-circle'></i>

          <span data-test-selector='annualized-spend-message'
                *ngIf="(selectedDateRange! | hasAnnualizedSpend)">{{annualizedSpendMessage}}
          </span>

          <span data-test-selector='potential-savings-message'
                *ngIf="isPotentialSavingsVisible">{{potentialSavingsMessage}}
          </span>
        </span>
      </div>
    </div>
    <div class="col-12">
      <app-date-range-picker [bounds]="dateRangeBounds"
                             [selectRange$]="selectedRange$"
                             [minSelectionCount]='minSelectionCount'
                             [maxSelectionCount]='maxSelectionCount'
                             (rangeChanged)="rangeChangeCallback($event)">
      </app-date-range-picker>
    </div>
  </div>
</div>

<!--
  Footer
-->
<div class="modal-footer">
  <button class="btn btn-primary" (click)="applyChanges()">
    Apply Changes
  </button>
</div>

